export default function rhinoConfig(
  $compileProvider,
  $logProvider,
  $httpProvider,
  $cookiesProvider,
  rnDebugEnabled,
  $locationProvider,
  $qProvider
) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  // if (__DEV__) { console.log('Rhino Config: Starting...'); }

  ///////////////////////////
  // Configure Compile Settings
  ///////////////////////////

  // Optimize angular gernated markup - don't include css hints that protractor and batarang need while in production
  $compileProvider.debugInfoEnabled(rnDebugEnabled);

  // Necessary because angular 1.6 has '!' as the default hash prefix.
  // See https://github.com/angular/angular.js/issues/15496
  $locationProvider.hashPrefix('');

  ///////////////////////////
  // Configure cookie Settings
  ///////////////////////////

  // Configure $cookiesProvider so that we can use cookies across all subdomains, make them only usable only if secure
  $cookiesProvider.defaults = {
    path: '/',
    secure: true
  };

  // Angular 1.6 - log errors for unhandled promises when in dev mode
  $qProvider.errorOnUnhandledRejections(__DEV__);

  // if (__DEV__) { console.log('Rhino Config: Finished.'); }
}

